import React, { useMemo, useState } from "react";
import "./MeetingsTabView.css";
import Pagination from "../../../../components/AdminCoachPanel/coaches/Pagination/Pagination";
import RangeDatePicker from "../../../AppLogs/components/datePicker";

/* -------------------------------
   COMPONENT
-------------------------------- */
export default function MeetingsTabView({ meetings = [] }) {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [dateRange, setDateRange] = useState({
    minDate: "",
    maxDate: "",
  });
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [activeRecordings, setActiveRecordings] = useState([]);
  const [activeRecordingUrl, setActiveRecordingUrl] = useState(null);
  

  const pageSize = 5;
  /* Use real meetings if exist, otherwise mock */
  const data = useMemo(() => {
    return meetings;
  }, [meetings]);
  

  function getStudentDisplayName(m) {
    if (m.studentName) return m.studentName;
    if (m.StudentName) return m.StudentName;
    if (m.StudentNickName) return m.StudentNickName;
    return "";
  }

  /* Search */
  // const filteredMeetings = data.filter((m) => {
  //   const name = getStudentDisplayName(m);
  //   return name.toLowerCase().includes(search.toLowerCase());
  // });

  const studentOptions = useMemo(() => {
    const map = {};
    data.forEach(function (m) {
      if (!map[m.studentId]) {
        map[m.studentId] = {
          id: m.studentId,
          name: m.studentName,
        };
      }
    });

    return Object.values(map).sort(function (a, b) {
      return a.name.localeCompare(b.name, "tr", { sensitivity: "base" });
    });
  }, [data]);

  const handleDateRangeChange = ({ minDate, maxDate }) => {
    setDateRange({ minDate, maxDate });
    setCurrentPage(1);
  };

  const filteredMeetings = useMemo(() => {
    return data.filter(function (m) {
      // Student filter
      const matchesStudent = selectedStudentId
        ? String(m.studentId) === String(selectedStudentId)
        : true;

      // Date filter
      const meetingDate = m.date ? new Date(m.date) : null;

      const matchesFrom = dateRange.minDate
        ? meetingDate >= dateRange.minDate
        : true;

      const matchesTo = dateRange.maxDate
        ? meetingDate <= dateRange.maxDate
        : true;

      return matchesStudent && matchesFrom && matchesTo;
    });
  }, [data, selectedStudentId, dateRange]);

  /* Pagination */
  const totalPages = Math.ceil(filteredMeetings.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedMeetings = filteredMeetings.slice(
    startIndex,
    startIndex + pageSize
  );

  function handleOpenRecording(recordings) {
    if (!recordings || recordings.length === 0) return;
  
    setActiveRecordings(recordings);
    setActiveRecordingUrl(recordings[0].RecordUrl); // latest auto-play
    setIsVideoOpen(true);
  }
  
  function handleCloseRecording() {
    setIsVideoOpen(false);
    setActiveRecordings([]);
    setActiveRecordingUrl(null);
  }
  

  function handleCloseRecording() {
    setIsVideoOpen(false);
    setActiveRecordings([]);
    setActiveRecordingUrl(null);
  }

  return (
    <div className="coach-profile-card">
      {/* Header */}
      <div className="meetings-header">
        <h3>Koçun Yaptığı Toplantılar</h3>
        <div className="meetings-filters">
          <div className="meetings-filter-select-wrapper">
            <select
              className="meetings-filter-select"
              value={selectedStudentId}
              onChange={(e) => {
                setSelectedStudentId(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">Tüm Öğrenciler</option>

              {studentOptions.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          <RangeDatePicker onChangeDateRange={handleDateRangeChange} />
        </div>
      </div>

      {/* Table */}
      <table className="meetings-table">
        <thead>
          <tr>
            <th>Tarih</th>
            <th>Öğrenci</th>
            {/* <th>Süre</th> */}
            {/* <th>Değerlendirme</th> */}
            <th>Toplantı Başlığı</th>
            <th>Aksiyonlar</th>
          </tr>
        </thead>

        <tbody>
          {paginatedMeetings.map((m) => (
            <tr key={m.id}>
              <td>
                <div className="meeting-date">
                  <div>
                    {new Date(m.date).toLocaleDateString("tr-TR", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    })}
                  </div>
                  <div className="meeting-time">
                    {m.time}
                  </div>
                </div>
              </td>

              <td>{getStudentDisplayName(m) || "-"}</td>

              {/* <td>{m.duration} dk</td> */}

              {/* <td>
                {m.rating ? (
                  <span className="meeting-rating">⭐ {m.rating}</span>
                ) : (
                  "-"
                )}
              </td> */}

                <td>{(m.title) || "-"}</td>


                <td className="meeting-actions">
  <div className="recording-btn-wrapper">
    <button
      className="btn-recording active"
      disabled={m.recordings.length === 0}
      onClick={() => handleOpenRecording(m.recordings)}
    >
      Toplantı Kaydı
    </button>

    {m.recordings.length === 0 && (
      <span className="recording-tooltip">
        Toplantı kaydı yoktur
      </span>
    )}
  </div>
</td>

            </tr>
          ))}
        </tbody>
      </table>

      {isVideoOpen && (
  <div className="video-modal-backdrop" onClick={handleCloseRecording}>
    <div className="video-modal" onClick={(e) => e.stopPropagation()}>
      <button className="video-modal-close" onClick={handleCloseRecording}>
        ✕
      </button>

      {/* VIDEO */}
      <div className="video-modal-player">
        <video
          key={activeRecordingUrl}
          src={activeRecordingUrl}
          controls
          autoPlay
        />
      </div>

      {/* RECORDING LIST */}
     {activeRecordings.length>1 &&  <div className="video-modal-list">
        {activeRecordings.map(function (r, index) {
          const isActive = r.RecordUrl === activeRecordingUrl;

          return (
            <div
              key={r.Id}
              className={
                "video-modal-list-item " + (isActive ? "active" : "")
              }
              onClick={() => setActiveRecordingUrl(r.RecordUrl)}
            >
              <span>Kayıt {index + 1}</span>
            </div>
          );
        })}
      </div>}
    </div>
  </div>
)}


      {/* Footer */}
      {/* <div className="meetings-footer">
        <span>
          Showing {paginatedMeetings.length} of {filteredMeetings.length} meetings
        </span> */}

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        totalItems={filteredMeetings.length}
        onPageChange={setCurrentPage}
      />
      {/* </div> */}
    </div>
  );
}
